module.exports = __webpack_public_path__ + "img/wine-glass-crack.66652be4.svg";